import { observer } from 'mobx-react-lite'
import { type FC, useMemo, useEffect } from 'react'
import { layoutStore } from 'shared/layout'
import {
  CallHistoryContext,
  useCallHistoryContext,
} from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'
import { useEventConversationUnread } from 'pages/conversations/pages/calls/ui/CallHistory/events/EventConversationUnread'
import { useEventMessageReceivedNew } from 'pages/conversations/pages/calls/ui/CallHistory/events/EventMessageReceivedNew'
import { useEventMessageUpdatedNew } from 'pages/conversations/pages/calls/ui/CallHistory/events/EventMessageUpdatedNew'
import { useEventVoicemailReceived } from 'pages/conversations/pages/calls/ui/CallHistory/events/EventVoicemailReceived'
import { useEventInboxCalling } from 'pages/conversations/pages/calls/ui/CallHistory/events/EventInboxCalling'
import { CallHistoryMobileContent } from 'pages/conversations/pages/calls/ui/CallHistory/ui/mobile/CallHistoryMobileContent'
import { CallHistoryWebContent } from 'pages/conversations/pages/calls/ui/CallHistory/ui/web/CallHistoryWebContent'

const CallHistoryContent = observer(() => {
  const store = useCallHistoryContext()
  const { dispose, disposeReactions, initReactions } = store
  const { isMobileView } = layoutStore

  useEventConversationUnread(store)
  useEventMessageReceivedNew(store)
  useEventMessageUpdatedNew(store)
  useEventVoicemailReceived(store)
  useEventInboxCalling(store)

  useEffect(() => {
    initReactions()

    return () => {
      dispose()
      disposeReactions()
    }
  }, [])

  return isMobileView ? <CallHistoryMobileContent /> : <CallHistoryWebContent />
})

type ICallHistoryProps = {
  store: CallHistoryStore
}

export const CallHistory: FC<ICallHistoryProps> = observer(({ store }) => {
  return useMemo(
    () => (
      <CallHistoryContext.Provider value={store}>
        <CallHistoryContent />
      </CallHistoryContext.Provider>
    ),
    []
  )
})
